import { render, staticRenderFns } from "./DeviceStockDetail.vue?vue&type=template&id=ab0b2b44&scoped=true&"
import script from "./DeviceStockDetail.vue?vue&type=script&lang=js&"
export * from "./DeviceStockDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeviceStockDetail.vue?vue&type=style&index=0&id=ab0b2b44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0b2b44",
  null
  
)

export default component.exports